/**
 * Required switch picker for build-to-order grid switch panels.
 * Markup: snippets/kt-grid-switch-picker.liquid. Tests: test/grid-switch-picker.test.js.
 *
 * The picker's <select name="properties[Switch N]"> elements live inside the
 * product form, so a normal add-to-cart carries them as line-item properties.
 * This script only has to stop an INCOMPLETE panel being added:
 *
 *  - main form: block submit/click until every position is chosen;
 *  - sticky add-to-cart (a separate form without the selects): block until the
 *    main picker is complete, then mirror the choices into that form as hidden
 *    inputs so the line carries them too.
 *
 * Listeners run in the CAPTURE phase on document, so they fire before the
 * theme's own add-to-cart handlers and can stop them. Nothing here knows about
 * switches, labels or counts — all of that comes from the markup (metafields).
 */
(function () {
  'use strict';
  if (window.__ktGridPickerBound) return;
  window.__ktGridPickerBound = true;

  var MIRROR_ATTR = 'data-kt-grid-picker-mirror';

  function pickers() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-kt-grid-picker]'));
  }

  function selectsOf(picker) {
    return Array.prototype.slice.call(picker.querySelectorAll('[data-kt-grid-picker-select]'));
  }

  function emptySelects(picker) {
    return selectsOf(picker).filter(function (s) { return !s.value; });
  }

  function pickerForProduct(productId) {
    var list = pickers();
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].getAttribute('data-product-id')) === String(productId)) return list[i];
    }
    return null;
  }

  function productIdOfForm(form) {
    if (!form) return null;
    var id = form.getAttribute('data-productid');
    if (id) return id;
    var input = form.querySelector('input[name="product-id"]');
    return input ? input.value : null;
  }

  function render(picker, showError) {
    var empty = emptySelects(picker);
    var err = picker.querySelector('[data-kt-grid-picker-error]');
    selectsOf(picker).forEach(function (s) {
      if (showError && !s.value) s.setAttribute('aria-invalid', 'true');
      else s.removeAttribute('aria-invalid');
    });
    if (!err) return empty;
    if (empty.length && showError) {
      var tpl = picker.getAttribute('data-incomplete-template') || '';
      var base = err.getAttribute('data-base-text');
      if (!base) { base = err.textContent; err.setAttribute('data-base-text', base); }
      err.textContent = tpl ? base + ' ' + tpl.replace('__COUNT__', String(empty.length)) : base;
      err.hidden = false;
    } else if (!empty.length) {
      err.hidden = true;
    }
    return empty;
  }

  function mirrorInto(form, picker) {
    Array.prototype.slice.call(form.querySelectorAll('[' + MIRROR_ATTR + ']')).forEach(function (n) {
      n.parentNode.removeChild(n);
    });
    selectsOf(picker).forEach(function (s) {
      var h = document.createElement('input');
      h.type = 'hidden';
      h.name = s.name;
      h.value = s.value;
      h.setAttribute(MIRROR_ATTR, '');
      form.appendChild(h);
    });
  }

  function block(evt, picker) {
    evt.preventDefault();
    evt.stopPropagation();
    if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
    var empty = render(picker, true);
    if (empty.length) {
      try { picker.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { picker.scrollIntoView(); }
      empty[0].focus({ preventScroll: true });
    }
  }

  /** Returns true if the event was blocked. */
  function guard(evt, form) {
    var pid = productIdOfForm(form);
    if (!pid) return false;
    var picker = pickerForProduct(pid);
    if (!picker) return false;
    var own = form.contains(picker);
    if (emptySelects(picker).length) { block(evt, picker); return true; }
    if (!own) mirrorInto(form, picker);
    return false;
  }

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || form.tagName !== 'FORM') return;
    guard(evt, form);
  }, true);

  /**
   * Product cards: the theme builds its quick-add buttons in JS from a template,
   * so the server cannot remove them. snippets/product-atc.liquid marks a picker
   * product's card with [data-kt-grid-picker-cta] (a link to the product page);
   * a quick-add click on such a card goes to that link instead of adding an
   * unconfigured panel.
   */
  var QUICK_ADD = '[data-atc-selector], [data-action-atc], [data-action-quickshop]';
  function cardCta(el) {
    var card = el.closest('.t4s-product');
    return card ? card.querySelector('[data-kt-grid-picker-cta]') : null;
  }

  function pickerForVariant(variantId) {
    var list = pickers();
    for (var i = 0; i < list.length; i++) {
      var ids = list[i].getAttribute('data-variant-ids') || '';
      if (ids.indexOf(',' + variantId + ',') !== -1) return list[i];
    }
    return null;
  }

  document.addEventListener('click', function (evt) {
    if (!evt.target || !evt.target.closest) return;
    var quick = evt.target.closest(QUICK_ADD);
    /*
     * Sticky add-to-cart bar (sections/main-product.liquid): a variant-id quick add
     * that posts only id + quantity. For a picker product, route it through the
     * main form instead — which carries the choices — or stop at the picker.
     */
    var vid = quick && quick.getAttribute('data-variant-id');
    var vPicker = vid ? pickerForVariant(vid) : null;
    if (vPicker) {
      evt.preventDefault();
      evt.stopPropagation();
      if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
      if (emptySelects(vPicker).length) { block(evt, vPicker); return; }
      var mainForm = vPicker.closest('form');
      var mainBtn = mainForm && mainForm.querySelector('button[name="add"]');
      if (mainBtn) mainBtn.click();
      return;
    }
    if (quick && !quick.hasAttribute('data-kt-grid-picker-cta')) {
      var cta = cardCta(quick);
      if (cta) {
        evt.preventDefault();
        evt.stopPropagation();
        if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
        window.location.href = cta.getAttribute('href');
        return;
      }
    }
    var btn = evt.target.closest('button[name="add"], [data-atc-form]');
    if (!btn) return;
    var form = btn.form || btn.closest('form');
    guard(evt, form);
  }, true);

  document.addEventListener('change', function (evt) {
    var s = evt.target;
    if (!s || !s.hasAttribute || !s.hasAttribute('data-kt-grid-picker-select')) return;
    var picker = s.closest('[data-kt-grid-picker]');
    if (picker) render(picker, false);
  });
})();
